import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './RoomBlockingForm.html?raw';
import on from 'dojo/on';

import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import '../../../moreCore/UI/GenericDialog/GenericDialog';
import { VAMtypes, OverlappingBookingsView } from "../../_loadingHelpers/VAM";
import DateTimeInput from '../../../moreCore/UI/DateTimeInput/DateTimeInput';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';



interface DateSetRegistry {
    dateSet: VAMtypes.DateSet,
    row: StaticTable.StaticTableRowGroup<VAMtypes.DateSet>
    inputDateStart: any,
    inputDateEnd: any,
    inputFulltime: any,
    overlappingView: MdsLax<InstanceType<typeof OverlappingBookingsView>>,
    overlappingDlg: MdsLax<InstanceType<typeof GenericDialog>>
}
interface RoomRegistry {
    ID: string,
    code: string,
    description: string,
    venueDescription: string
    row: StaticTable.StaticTableRowGroup<any>
}
class RoomBlockingForm extends compose(_WidgetBaseSP, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private headingText: HTMLElement;
    private datesetContainer: HTMLElement;
    private roomTableContainer: HTMLElement;
    private roomInput_container: HTMLElement;
    private evProjectInput_container: HTMLElement;
    private sectionTargetDates: HTMLElement;


    private roomInput: MdsLax<InstanceType<typeof HintBox>>;
    private evProjectInput: MdsLax<InstanceType<typeof HintBox>>;

    private datesTable: MdsLax<InstanceType<typeof StaticTable>>;
    private roomsTable: MdsLax<InstanceType<typeof StaticTable>>;

    private datesRegistry: Array<DateSetRegistry>;
    private roomRegistry: Array<RoomRegistry>;

    private formData: VAMtypes.RoomBlockingFormData = null;

    private _defaultParameters: {
        dateStart: Date,
        dateEnd: Date
    } = null;

    private _room_tableFormatter(cell: StaticTable.StaticTableCell<any>): boolean {

        let cellname = cell.name;

        let regEntry: RoomRegistry = this.roomRegistry[cell.tableRow.rowGroup.rowIndex];
        let entity = cell.entity;

        regEntry.row = cell.tableRow.rowGroup;

        switch (cellname) {
            case "roomActions":
                let btn = this.UiModder.domConstruct.create("button", {
                    className: "mds-button-base round hoverBright deleteBtn",
                    innerHTML: this.createFontawesomeIcon("fas fa-trash warningTXT").outerHTML
                }, cell.tableCellNode);

                on(btn, "click", lang.hitch(this, this._onClick_RemoveRoom, cell.tableRow.rowGroup.rowIndex));

                return true;
                break;
        }

        return false;
    }

    private _tableFormatter(cell: StaticTable.StaticTableCell<VAMtypes.DateSet>): boolean {

        let cellname = cell.name;

        let regEntry: DateSetRegistry = this.datesRegistry[cell.tableRow.rowGroup.rowIndex];
        let entity = cell.entity;

        regEntry.row = cell.tableRow.rowGroup;


        switch (cellname) {
            case "actions":
                let btn = this.UiModder.domConstruct.create("button", {
                    className: "mds-button-base round hoverBright deleteBtn",
                    innerHTML: this.createFontawesomeIcon("fas fa-trash warningTXT").outerHTML
                }, cell.tableCellNode);

                on(btn, "click", lang.hitch(this, this._onClick_RemoveDateSet, cell.tableRow.rowGroup.rowIndex));

                return true;
                break;

            case "conflicts":

                if (regEntry.overlappingView != null) {
                    regEntry.overlappingView.destroy();
                }
                regEntry.overlappingView = new OverlappingBookingsView();
                regEntry.overlappingView.on("dataReceived", lang.hitch(this, this._onOverlappingDataReceived, cell));

                this.setOverlappingViewParametersForEntry(regEntry);

                return true;
                break;

            case "dateStart":
                let inputDs = new DateTimeInput();
                inputDs.setValue(cell.entity.dateStart, true);
                inputDs.placeAt(cell.tableCellNode);

                if (cell.entity.isFulltime === true) {
                    inputDs.useTimeInput(false);
                }

                on(inputDs, "change", lang.hitch(this, this._onChangeTblCellValue, cell, regEntry));

                regEntry.inputDateStart = inputDs;

                this._adjustDateTimeToFulltime(regEntry);

                return true;
                break;

            case "dateEnd":
                let inputDe = new DateTimeInput();
                inputDe.setValue(cell.entity.dateEnd, true);
                inputDe.placeAt(cell.tableCellNode);

                if (cell.entity.isFulltime === true) {
                    inputDe.useTimeInput(false);
                    //inputDe.setReadonly(true);
                    //inputDe.setValue(cell.entity.dateStart, true);
                }

                on(inputDe, "change", lang.hitch(this, this._onChangeTblCellValue, cell, regEntry));

                regEntry.inputDateEnd = inputDe;

                this._adjustDateTimeToFulltime(regEntry);

                return true;
                break;

            case "isFulltime":

                let inputFt = new CheckBox();
                inputFt.setValue(cell.entity.isFulltime, true);
                inputFt.placeAt(cell.tableCellNode);
                on(inputFt, "change", lang.hitch(this, this._onChangeTblCellValue, cell, regEntry));

                regEntry.inputFulltime = inputFt;

                this._adjustDateTimeToFulltime(regEntry);

                return true;
                break;
        }

        return false;
    }

    private _onChange_Any(value?: any) {

        let room = this.roomInput.getValue("entity");
        if (room != null) {

            this.addRoomToTable(room);

            this.drawTable("room");
            this.roomInput.setValue(null, true);
        }

        this.delayedSerializeData(50);

        for (let entry of this.datesRegistry) {
            this.setOverlappingViewParametersForEntry(entry);
        }
    }

    private _onClick_RemoveDateSet(index: number) {
        this.datesRegistry.splice(index, 1);

        this.drawTable("dates");

        this.delayedSerializeData();
    }

    private _onClick_RemoveRoom(index: number) {
        this.roomRegistry.splice(index, 1);

        this.drawTable("room");
        this.datesRegistry.forEach(entry => this.setOverlappingViewParametersForEntry(entry));

        this.delayedSerializeData();
    }

    private _onClick_OpenRoomSED(evt) {
        this.loadSelectEntityDialog(evt,
            "selectEvRoomAll",
            lang.hitch(this, this._onSelectEntityDialog_Callback_Dlg)
        );
    }

    private _onClick_OpenProjectSED(evt) {
        this.loadSelectEntityDialog(evt,
            "selectEvProject",
            lang.hitch(this, this._onSelectEntityDialog_Callback_Dlg)
            //lang.hitch(this, this._onSelect_CreateNewEvProject)
        );
    }

    private _onSelectEntityDialog_Callback_Dlg(mode: string, data, items) {

        switch (mode) {
            case "selectEvRoomAll":

                items.forEach(item => {
                    let room = item["entry"]["data"];
                    this.addRoomToTable(room);
                });

                this.drawTable("room");

                this.roomInput.setValue(null);
                break;
            case "selectEvProject":

                let project = items[0].entry.data;
                this.evProjectInput.setValue(project);
                break;
            default:
        }
        //    if (mode == "selectEvRoomAll") {
        //        let room = items[0].entry.data;
        //        this.roomInput.setValue(room);
        //    }
    }

    private _onChangeTblCellValue(cell: StaticTable.StaticTableCell<VAMtypes.DateSet>, registryEntry: DateSetRegistry) {

        let entity = cell.entity;
        let targetProperty = cell.name;

        switch (targetProperty) {
            case "isFulltime":
                let isFulltime = registryEntry.inputFulltime.getValue() as boolean;
                entity.isFulltime = isFulltime;

                registryEntry.inputDateStart.useTimeInput(!isFulltime);
                registryEntry.inputDateEnd.useTimeInput(!isFulltime);

                this._adjustDateTimeToFulltime(registryEntry);

                break;

            case "dateStart":
                let newDateStartValue = (registryEntry.inputDateStart as MdsLax<InstanceType<typeof DateTimeInput>>).getValue();
                if (newDateStartValue.date != null && newDateStartValue.date instanceof Date) {

                    entity.dateStart = newDateStartValue.date;

                    if (entity.dateStart.valueOf() > entity.dateEnd.valueOf()) {

                        entity.dateEnd = entity.dateStart;
                        (registryEntry.inputDateEnd as MdsLax<InstanceType<typeof DateTimeInput>>).setValue(entity.dateEnd, true);
                        this._adjustDateTimeToFulltime(registryEntry);
                    }
                }
                break;

            case "dateEnd":
                let dateValue = (registryEntry.inputDateEnd as MdsLax<InstanceType<typeof DateTimeInput>>).getValue();
                if (dateValue.date != null && dateValue.date instanceof Date) {
                    entity[targetProperty] = dateValue.date;

                    if (entity.dateStart.valueOf() > entity.dateEnd.valueOf()) {

                        entity.dateStart = entity.dateEnd;
                        (registryEntry.inputDateStart as MdsLax<InstanceType<typeof DateTimeInput>>).setValue(entity.dateStart, true);
                        this._adjustDateTimeToFulltime(registryEntry);
                    }
                }
                break;


            default:

                break;
        }

        if (entity.dateStart && entity.dateEnd) {
            //try {
            //    if (!entity.isFulltime) {
            //        if (entity.dateStart.valueOf() > entity.dateEnd.valueOf()) {
            //            entity.dateEnd = entity.dateStart;

            //            this.datesTable.updateEntity(entity, cell.tableRow.rowGroup.rowIndex);
            //        }
            //    } else {
            //        registryEntry.inputDateEnd.useTimeInput(!entity.isFulltime);
            //    }
            //} catch (ex) {

            //}

            if (registryEntry.overlappingView) {
                this.setOverlappingViewParametersForEntry(registryEntry);
            }
        }

        this.delayedSerializeData();
    }

    private _onClick_OverlappingDetails(entry: DateSetRegistry) {
        if (entry.overlappingDlg == null) {
            entry.overlappingDlg = new GenericDialog();
        }
        entry.overlappingDlg.setCloseOnEscape(true);
        entry.overlappingDlg.set("closeBtn", true);
        entry.overlappingDlg.set("header", this.translations["RoomBlockingForm__Label_Overlappings"]);
        entry.overlappingDlg.addNodeToContent(entry.overlappingView.domNode);
        entry.overlappingDlg.destroyOnClose = false;
        entry.overlappingDlg.show();
    }

    private _onOverlappingDataReceived(cell: StaticTable.StaticTableCell<VAMtypes.DateSet>, overlappingData: Array<object>) {
        let regEntry: DateSetRegistry = this.datesRegistry[cell.tableRow.rowGroup.rowIndex];

        this.UiModder.domConstruct.empty(cell.tableCellNode);

        if (overlappingData.length > 0) {
            let btnOverlapping = this.UiModder.domConstruct.create("button", {
                className: "mds-button-base round hoverBright w3-red",
                innerHTML: this.createFontawesomeIcon("fas fa-exclamation-triangle").outerHTML
            }, cell.tableCellNode);

            on(btnOverlapping, "click", lang.hitch(this, this._onClick_OverlappingDetails, regEntry));
        } else {

            let btnNoOverlapping = this.UiModder.domConstruct.create("button", {
                className: "mds-button-base round hoverBright w3-green",
                innerHTML: this.createFontawesomeIcon("fas fa-check").outerHTML
            }, cell.tableCellNode);

            on(btnNoOverlapping, "click", lang.hitch(this, this._onClick_OverlappingDetails, regEntry));
        }
    }

    private _onClick_AddDateset(evt: MouseEvent) {
        this.addDateSet();
    }

    private addDateSet() {
        let set: VAMtypes.DateSet = {
            dateStart: this._defaultParameters.dateStart,
            dateEnd: this._defaultParameters.dateEnd,
            isFulltime: true
        };

        let reg: DateSetRegistry = {
            dateSet: set,
            row: null,
            inputDateStart: null,
            inputDateEnd: null,
            inputFulltime: null,
            overlappingView: null,
            overlappingDlg: null
        };
        this.datesRegistry.push(reg);

        //this.drawDatesetTable();
        this.drawTable("dates");

        this.delayedSerializeData();
    }

    private _serializeHandle: any = null;
    private delayedSerializeData(delay: number = 200) {
        if (this._serializeHandle != null) {
            clearTimeout(this._serializeHandle);
            this._serializeHandle = null;
        }

        this._serializeHandle = setTimeout(lang.hitch(this, this.serializeData), delay);
    }
    private serializeData() {
        this._serializeHandle = null;

        this.formData = {
            evRoomID: null,//this.roomInput.getValue("value"),
            datesToBlock: [],
            listEvRoomID: [],
            evProjectID: this.evProjectInput.getValue("value")
        };

        this.roomRegistry.forEach(reg => {

            this.formData.listEvRoomID.push(reg.ID);
        });

        for (let set of this.datesRegistry) {
            //this.formData.datesToBlock.push(set.dateSet);
            this.formData.datesToBlock.push({
                dateStart: this.dateToLocalISOString(set.dateSet.dateStart),
                dateEnd: this.dateToLocalISOString(set.dateSet.dateEnd),
                isFulltime: set.dateSet.isFulltime
            });
        }

        this.emit("result", this.validate());
        console.log("serializeData", this.formData);
    }

    getData() {
        return this.formData;
    }

    private validate(): boolean{
        let result: boolean = true;

        this.UiModder.domClass.toggle(this.sectionTargetDates, "warningBG", !this.formData.datesToBlock.length);
        this.UiModder.domClass.toggle(this.roomInput_container, "warningBG", !this.formData.listEvRoomID.length);
        this.UiModder.domClass.toggle(this.evProjectInput_container, "warningBG", !this.evProjectInput.validateInput());

        if (!this.evProjectInput.validateInput()) result = false;

        if (!this.formData) result = false;

        if (!this.formData.datesToBlock || !this.formData.datesToBlock.length) result = false;
        if (!this.formData.listEvRoomID || !this.formData.listEvRoomID.length) result = false;

        this.datesRegistry.forEach(entry => {

            this.UiModder.domClass.remove(entry.row.rows[0].node, "warningBG");

            if (this.datesRegistry.filter(x => x.dateSet.dateStart < entry.dateSet.dateEnd && x.dateSet.dateEnd > entry.dateSet.dateStart).length > 1) {

                this.UiModder.domClass.add(entry.row.rows[0].node, "warningBG");
                result = false;
            }
        });

        return result;
    }

    private drawTable(mode: "room" | "dates"): void {

        switch (mode) {
            case "dates":
                this.UiModder.domConstruct.empty(this.datesetContainer);

                this.datesTable = new StaticTable();
                this.datesTable.placeAt(this.datesetContainer);

                this.datesTable.setVerticalAlign("middle");

                this.datesTable.addLineConfig({
                    attributes: ["dateStart", "dateEnd", "isFulltime"],
                    colNamesInternal: ["dateStart", "dateEnd", "isFulltime", "conflicts", "actions"],
                    headings: [
                        this.translations["EvBookingditor_dateStart_inputLabel"],
                        this.translations["EvBookingditor_dateEnd_inputLabel"],
                        this.translations["General_Label_IsFullTime"],
                        this.translations["RoomBlockingForm__Label_Overlappings"],
               /* this.translations["General_Label_Actions"]*/""],
                    colspans: [1, 1, 1, 1],
                    widths: [null, null, "10ch", "10ch", "15ch"],
                    alignmentsRow: [null, null, null, "right", "right"],
                    alignmentsHeading: [null, null, null, "right", "right"]
                });

                this.datesTable.setFormatter(lang.hitch(this, this._tableFormatter));

                this.datesTable.setData(this.datesRegistry.map(entry => entry.dateSet));
                this.datesTable.setCyAttribute("roomBlockingDates");
                break;
            case "room":
                this.UiModder.domConstruct.empty(this.roomTableContainer);

                this.roomsTable = new StaticTable();
                this.roomsTable.placeAt(this.roomTableContainer);

                this.roomsTable.setVerticalAlign("middle");

                this.roomsTable.addLineConfig({
                    attributes: ["code", "description", "venueDescription"],
                    colNamesInternal: ["code", "description", "venueDescription", "roomActions"],
                    headings: [
                        this.translations["General_Label_Code"],
                        this.translations["General_Description"],
                        this.translations["General_Label_Venue"],
                        ""],
                    colspans: [1, 1, 1, 1],
                    widths: ["15ch", null, null, "15ch"],
                    alignmentsRow: [null, null, null, "right"],
                    alignmentsHeading: [null, null, null, "right"]
                });

                this.roomsTable.setFormatter(lang.hitch(this, this._room_tableFormatter));

                this.roomsTable.setData(this.roomRegistry);
                this.roomsTable.setCyAttribute("roomBlockingRooms");
                break;
        }
    }

    private addRoomToTable(room: any): void {

        if (this.roomRegistry.indexOf(this.roomRegistry.filter(x => x.ID === room["ID"])[0]) == -1) {
            this.roomRegistry.push({
                ID: room["ID"],
                code: room["code"],
                description: room["description"],
                venueDescription: room["venueDescription"],
                row: null
            });
        }
    }

    private setOverlappingViewParametersForEntry(entry: DateSetRegistry): void {

        let entity = entry.dateSet;

        entry.overlappingView.SetParameters({
            start: entity.dateStart,
            end: entity.dateEnd,
            roomId: null,//this.roomInput.getValue("value"),
            selfBookingId: null,
            isWithRoomList: true,
            listRoomId: this.roomRegistry.map(x => x.ID)
        });
    }

    private _adjustDateTimeToFulltime(registryEntry: DateSetRegistry) {
        if (registryEntry.inputDateEnd == null || registryEntry.inputDateStart == null || registryEntry.inputFulltime == null) {
            return;
        }

        if (registryEntry.inputFulltime.getValue() === true) {
            let dateStartInpt = registryEntry.inputDateStart as MdsLax<InstanceType<typeof DateTimeInput>>;
            let date_start = dateStartInpt.getValue();
            date_start.date.setHours(0);
            date_start.date.setMinutes(0);
            date_start.date.setSeconds(0);

            dateStartInpt.setValue(date_start.date);

            let dateEndInpt = registryEntry.inputDateEnd as MdsLax<InstanceType<typeof DateTimeInput>>;
            let date_end = lang.clone( dateEndInpt.getValue() );
            date_end.date.setHours(23);
            date_end.date.setMinutes(59);
            date_end.date.setSeconds(59);

            dateEndInpt.setValue(date_end.date);
        }
    }

    setup(
        title: string,
        dateValues: VAMtypes.DateSet) {
        this._defaultParameters = {
            dateStart: dateValues.dateStart,
            dateEnd: dateValues.dateEnd
        };

        //this.roomInput.setValue(sourceBooking.ref_ev_room);

        this.headingText.innerHTML = title ? title : "?";

        this.addDateSet();
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.SEDconfigCallfunction = "Webtool_API_EvBooking__SED_GetConfig";

        this.datesRegistry = [];
        this.roomRegistry = [];

        this.roomInput.addInlineButton(lang.hitch(this, this._onClick_OpenRoomSED));
        this.evProjectInput.addInlineButton(lang.hitch(this, this._onClick_OpenProjectSED));

    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(RoomBlockingForm);
